<template>
    <b-card
        header-tag="header"
        footer-tag="footer"
        class="mb-3 treatment-detail"
        body-class="p-2"
        footer-class="p-0"
    >
        <b-card-text
            class="my-0"
            style="
                margin-bottom: -0.3rem !important;
                margin-top: -0.3rem !important;
            "
        >
            <b-row>
                <b-col md="6">
                    <b-row align-v="center">
                        <b-col
                            v-if="data.patient"
                            class="border-right"
                            style="max-width: 250px;"
                        >
                            <!-- <b-img
                                v-if="
                                    data.patient.photo &&
                                    !data.patient.photo.includes(
                                        'no_avatar.png'
                                    )
                                "
                                :src="
                                    _s3URL('patient', data.patient.id) +
                                    'photos/thumb_' +
                                    data.patient.photo
                                "
                                :alt="data.patient.name"
                                rounded="circle"
                                thumbnail
                                class="float-left mr-3"
                            ></b-img>
                            <b-img
                                v-else
                                :alt="data.patient.name"
                                src="assets/no_avatar.png"
                                rounded="circle"
                                thumbnail
                                class="float-left mr-3"
                            ></b-img> -->
                            <div style="margin-left: 0.5rem;">
                                <a :href="data.patient.ci_url">{{
                                    getPatientName(data)
                                }}</a>
                                <p class="mb-0">{{ data.admitted_for }}</p>
                            </div>
                        </b-col>

                        <b-col
                            v-if="
                                isLoadingTriage ||
                                isLoadingGetTreatmentList[data.id]
                            "
                            class="border-right col-3 text-nowrap"
                        >
                            Loading...
                        </b-col>

                        <b-col
                            v-else-if="
                                data.active_triage &&
                                data.active_triage.id &&
                                data.active_triage.isactive &&
                                !isSetTriage
                            "
                            class="border-right col-3 text-nowrap"
                        >
                            <span
                                :style="setTriageStyle(data)"
                                class="triage-badge"
                                :class="{
                                    'cursor-pointer': !_isTvView,
                                    'cursor-not-allowed': _isTvView
                                }"
                                title="Triage"
                                @click="editTriage()"
                                >{{
                                    data.active_triage.active_triage_type.triage
                                }}</span
                            >
                        </b-col>

                        <b-col
                            v-else-if="!_isTvView && isSetTriage"
                            class="border-right col-3 text-nowrap"
                        >
                            <span>
                                <div class="d-flex align-items-center">
                                    <select
                                        id="triage_id"
                                        v-model="triageSelected"
                                        class="form-control mr-1"
                                        name="triage_id"
                                    >
                                        <option
                                            v-for="triage in triageOptions"
                                            :key="triage.id"
                                            :value="triage.id"
                                            >{{ triage.triage }}</option
                                        >
                                    </select>
                                    <i
                                        class="fas fa-check btn-inline-edit"
                                        @click="setTriageAppointment(data)"
                                    ></i>
                                    <i
                                        class="fas fa-times btn-inline-edit"
                                        @click="isSetTriage = false"
                                    ></i>
                                </div>
                            </span>
                        </b-col>

                        <b-col v-else class="border-right col-3 text-nowrap">
                            <span
                                @click="editTriage()"
                                class="cursor-pointer text-link"
                            >
                                Triage
                            </span>
                        </b-col>

                        <b-col class="border-right py-2 col-5 text-nowrap">
                            <i
                                v-if="_.some($store.state.status)"
                                class="famfamfam-silk"
                                :class="status.icon"
                            ></i>
                            <a
                                v-if="data.rooms.length && data.rooms[0].id"
                                @click.prevent="statusClick"
                                href="status"
                                >{{ status.value }} {{ getRoomName() }}</a
                            >
                            <a
                                v-else
                                @click.prevent="statusClick(data)"
                                href="status"
                            >
                                {{ status.value }}
                            </a>
                            <p class="mb-0" style="height: 1.5rem;">
                                <span>
                                    {{ durationText }}
                                </span>
                            </p>
                            <!-- <p class="mb-0" style="height: 1.5rem;">
                                <span
                                    v-for="(staff, index) in data.staffs"
                                    :key="staff.id"
                                >
                                    {{
                                        (index > 0 ? ", " : "") +
                                        staff.firstname +
                                        " " +
                                        staff.lastname[0] +
                                        "."
                                    }}
                                </span>
                            </p> -->
                        </b-col>
                    </b-row>
                </b-col>
                <b-col>
                    <b-row align-v="center" class="h-100 vitals-row">
                        <b-col class="border-right text-center px-3">
                            <div style="white-space: nowrap;">
                                <i class="famfamfam-silk folder_page_white"></i>
                                <a
                                    v-if="
                                        documents.length > 0 &&
                                        data.treatment_status[0].status_id !== 1
                                    "
                                    href
                                    @click.prevent="document_dialog()"
                                    >&nbsp;Documents&nbsp;({{
                                        documents.length
                                    }})</a
                                >
                                <span v-else>&nbsp;Documents&nbsp;(0)</span>
                            </div>
                        </b-col>
                        <b-col
                            v-for="vital in vitalMap"
                            :key="vital.id"
                            :title="vital.title"
                            class="border-right text-center px-1"
                        >
                            <div>
                                <i :class="vital.icon"></i>
                                <h4>
                                    {{ vital.value }}
                                </h4>
                                <span>
                                    {{ vital.uom }}
                                </span>
                            </div>
                            <small class="pt-1 text-muted">{{
                                vital.taken
                            }}</small>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card-text>
        <template v-slot:footer>
            <activities-card :dialogs="dialogs" :data="data" />
        </template>
    </b-card>
</template>
<script>
import ScheduleHelper from "../helper";
import "../../commons/helper";
import ActivitiesCard from "./activity-card";
import { find, filter, size, some, uniqBy, merge } from "lodash";
import { DateTime, Interval } from "luxon";
import humanizeDuration from "humanize-duration";
import TriageService from "@/services/triage";
import CensusMixin from "@/mixins/census";

export default {
    name: "TreatmentRow",
    components: {
        ActivitiesCard
    },
    mixins: [ScheduleHelper, CensusMixin],
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        },
        dialogs: {
            type: Object,
            default() {
                return {};
            }
        },
        isLoadingGetTreatmentList: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            vitals: [],
            vital: "",
            scroll: {
                right: false,
                left: false
            },
            intervalId: 0,
            durationInterval: 0,
            dateTimeNow: this._now(),
            durationText: "",
            documents: [],
            isLoadingTriage: false,
            isSetTriage: false,
            triageSelected: null,
            triageOptions: []
        };
    },
    computed: {
        /**
         * Translate index and module name to tbl_status id
         * @return {Object} status object.
         */
        status() {
            return some(this.$store.state.status)
                ? find(this.$store.state.status, {
                      index: this.data.treatment_status[0].status_id,
                      module_name: "schedule.treatment"
                  })
                : {};
        },
        master_vitals() {
            return this.$store.state.reference
                ? this.$store.state.reference["master-vital"]
                : [];
        },
        vitalMap() {
            let self = this;
            return [
                {
                    icon: "famfamfam-silk anchor",
                    id: 4,
                    default: self._setting.weights_measures === 1 ? "Lbs" : "kg"
                },
                { icon: "famfamfam-silk heart", id: 1, default: "bpm" },
                { icon: "famfamfam-silk clock", id: 2, default: "rpm" },
                {
                    icon: "cus-thermometer",
                    id: 3,
                    default: self._setting.weights_measures === 1 ? "°F" : "°C"
                }
            ].map(vital => {
                let currentVital = find(self.vitals, { type: vital.id });
                let inTreatment = true;
                if (vital.id !== 4) {
                    inTreatment =
                        currentVital && self.data.start > 0
                            ? currentVital.updatedAt >
                              DateTime.fromMillis(self.data.start)
                            : false;
                }
                return {
                    ...vital,
                    title: some(self.master_vitals)
                        ? find(self.master_vitals, { id: vital.id }).vital
                        : "",
                    value:
                        currentVital && inTreatment ? currentVital.value : "--",
                    uom: currentVital ? currentVital.uom : vital.default,
                    taken:
                        currentVital && inTreatment
                            ? self
                                  ._toDateTime(currentVital.date)
                                  .toFormat(self._dateFormat + " hh:mm a")
                            : "--"
                };
            });
        }
    },
    sockets: {
        "v-broadcast-all"(params) {
            if (
                params.action === "refresh-vital" &&
                params.patient_id === this.data.patient.id
            ) {
                this.getPatientVital();
            }
            if (
                params.action === "refresh-document" &&
                params.patient_id === this.data.patient.id
            ) {
                this.getDocuments();
            }
        }
    },
    mounted() {
        this.getPatientVital();
        this.admitDuration();
        this.getAdmittedDuration();
        this.getDocuments();
        if (this.data && size(this.data.activities)) {
            this.intervalId = setInterval(() => {
                this.now = this._now();
            }, 3000);
        }
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
        clearInterval(this.durationInterval);
    },
    methods: {
        admitDuration() {
            this.durationInterval = setInterval(() => {
                this.dateTimeNow = this._now();
                this.getAdmittedDuration();
            }, 60000);
        },
        getAdmittedDuration() {
            let admitted = this._fromDateCarbon(this.data.create_at);
            let currentTime = this.dateTimeNow;
            let duration = Interval.fromDateTimes(admitted, currentTime)
                .toDuration()
                .valueOf();

            let durationHumanize = humanizeDuration(duration, {
                delimiter: " ",
                units: ["d", "h", "m"],
                round: true
            });

            if (this.data.appointment_id) {
                this.durationText = durationHumanize + " since checked in";
            } else {
                this.durationText = durationHumanize + " since admitted";
            }
        },
        getPatientName(object) {
            let primaryOwner = object.patient.primary_owner[0];

            if (primaryOwner) {
                return object.patient.name + " " + primaryOwner.lastname;
            } else {
                return object.patient.name;
            }
        },
        getRoomName() {
            let self = this;
            let room = filter(self.data.rooms, { pivot: { isactive: 1 } });

            return room.length > 0 ? "(" + room[0].name + ")" : "";
        },
        async getTreatmentSummary() {
            let self = this;
            return await this.$http
                .get(
                    process.env.BARRAMUNDI +
                        "schedule/treatment-summary/" +
                        self.data.id
                )
                .then(response => {
                    if (response.data.response.message.code === 200) {
                        let treatmentSummary = {
                            name: "Treatment Summary",
                            uri: response.data.response.resources.path,
                            module: "treatmentSummary"
                        };
                        self.documents.push(treatmentSummary);
                    }
                });
        },
        getDocuments() {
            return this.$http
                .get(
                    process.env.BARRACUDA +
                        "schedule/treatment-documents/" +
                        this.data.id
                )
                .then(response => {
                    if (response.data.response.resources) {
                        this.documents = uniqBy(
                            response.data.response.resources.data,
                            "name"
                        );
                    }
                    this.getTreatmentSummary();
                    return this.documents;
                });
        },
        getPatientVital() {
            let self = this;
            self.$store
                .dispatch("patient/getLatestVital", self.data.patient.id)
                .then(function (responses) {
                    responses.map(element => {
                        merge(element, {
                            date: self._fromDateCarbon(element.dateCarbon),
                            updatedAt: self._fromDateCarbon(
                                element.updatedAtCarbon
                            )
                        });
                    });
                    self.vitals = responses;
                });
        },
        statusClick() {
            this.dialogs["statusModal"].open(this.data);
        },
        document_dialog() {
            this.dialogs["documentModal"].open(this.data);
        },
        setTriageStyle(data) {
            return {
                backgroundColor: data.active_triage.active_triage_type
                    .background_color_code
                    ? "#" +
                      data.active_triage.active_triage_type
                          .background_color_code
                    : "",
                color: data.active_triage.active_triage_type.text_color_code
                    ? "#" +
                      data.active_triage.active_triage_type.text_color_code
                    : "",
                borderColor: data.active_triage.active_triage_type
                    .border_color_code
                    ? "#" +
                      data.active_triage.active_triage_type.border_color_code
                    : ""
            };
        },
        editTriage() {
            if (!this._isTvView) {
                this.getTriageList();
                this.isSetTriage = true;
            }
        },
        async getTriageList() {
            this.isLoadingTriage = true;
            await TriageService.getTriageTypeLists()
                .then(res => {
                    if (res && res.code === 200) {
                        // set selected triage to data or default as type 5
                        this.triageSelected =
                            this.data?.active_triage?.triage_type_id ?? 5;
                        this.triageOptions = res.resources;
                    } else {
                        throw new Error(
                            "Error: Unable to get the triage list."
                        );
                    }
                })
                .catch(e => {
                    console.error(e);
                    this._message(
                        "Error: Unable to get the triage list.",
                        "danger"
                    );
                })
                .finally(() => {
                    this.isLoadingTriage = false;
                });
        },
        async setTriageAppointment(data) {
            this.isLoadingTriage = true;

            let params = {
                triage_type_id: this.triageSelected,
                appointment_id: data?.appointment_id,
                treatment_board_id: data?.id,
                process_type: "treatment_board"
            };

            await TriageService.createNewTriage(params)
                .then(res => {
                    if (res && res.code === 200) {
                        this.$root.$emit(
                            "treatment-board-refresh",
                            this.data?.id
                        );
                    } else {
                        throw new Error("Error: Unable to set triage.");
                    }
                })
                .catch(e => {
                    console.error(e);
                    this._message("Error: Unable to set triage.", "danger");
                })
                .finally(() => {
                    this.isSetTriage = false;
                    this.isLoadingTriage = false;

                    // Emit socket to refresh census
                    const payload = {
                        appointmentDate: this.data?.start,
                        appointmentId: this.data?.appointment_id,
                        instanceId: this.instanceId
                    };

                    this.refreshCensus(payload);
                });
        }
    }
};
</script>
<style lang="scss">
@keyframes blinking {
    0% {
        background: white;
    }
    50% {
        background: #f5c6cb;
    }
    100% {
        background: white;
    }
}
.treatment-detail {
    h4 {
        display: inline;
        font-weight: 100;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }
    .activity-group {
        display: inline;
        .card {
            cursor: pointer;
            .card-body {
                .alert {
                    padding: 0.1rem 0.1rem;
                    margin-bottom: 0;
                    &.alert-danger {
                        animation: blinking 4s ease-in-out infinite;
                    }
                }
                p {
                    padding-bottom: 0rem;
                    margin-bottom: 0rem;
                    height: 1rem;
                    position: relative;
                    float: left;
                    left: 50%;
                    transform: translate(-50%, 14%);
                }
                min-height: 3.8rem;
            }
            min-width: 7.5rem;
            max-width: 7.5rem;
            max-height: 3.8rem;
            margin-right: 0.5rem;
        }
    }
    img.img-thumbnail {
        height: 3.5rem;
        width: 3.5rem;
        overflow: hidden;
    }
    .activity-group {
        display: flex;
        flex-wrap: nowrap;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
    }
    .activity-group::-webkit-scrollbar {
        display: none;
    }
}
.vitals-row {
    h4 {
        padding: 0;
    }
    > * {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 3rem;
    }
}
.activity-popover {
    // min-width: 10rem;
    .popover-body {
        padding: 0.2rem 0.2rem;
    }
}
.document {
    max-width: fit-content;
    padding-top: 1.1rem !important;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
}
#confirmDeleteModal footer .btn.btn-secondary {
    margin-right: auto;
}
</style>
